import { PageTypeEnum } from './PageTypeEnum'

export enum EntityTypeEnum {
  InnerItem = 'InnerItem',
  Carousel = 'Carousel',
  CarouselItem = 'CarouselItem',
  Faq = 'Faq',
  FaqItem = 'FaqItem',
  PricePlanCalculator = 'PricePlanCalculator', // removed
  WebinarRegistrationDate = 'WebinarRegistrationDate',
  Text = 'Text',
  TwitterTweetButton = 'TwitterTweetButton',
  Headline = 'Headline',
  CustomLogin = 'CustomLogin',
  CustomLoginForgotPassword = 'CustomLoginForgotPassword',
  BlogPostImage = 'BlogPostImage',
  ContentTable = 'ContentTable',
  Breadcrumbs = 'Breadcrumbs',
  ContactUs = 'ContactUs',
  Countdown = 'Countdown',
  ContentBox = 'ContentBox',
  TextArea = 'TextArea',
  Field = 'Field',
  Form = 'Form',
  Button = 'Button',
  WebsiteButton = 'WebsiteButton',
  LoginButton = 'LoginButton',
  RegistrationButton = 'RegistrationButton',
  ContactUsButton = 'ContactUsButton',
  Recaptcha = 'Recaptcha',
  Attachments = 'Attachments',
  OrderSummary = 'OrderSummary',
  BlogPostDate = 'BlogPostDate',
  BlogPostTitle = 'BlogPostTitle',
  Survey = 'Survey',
  UpsellAgreeButton = 'UpsellAgreeButton',
  UpsellDisagreeButton = 'UpsellDisagreeButton',
  Menu = 'Menu',
  BlogPostCategories = 'BlogPostCategories',
  Video = 'Video',
  Image = 'Image',
  BlogContentPlaceholder = 'BlogContentPlaceholder',
  BlogPostContentPlaceholder = 'BlogPostContentPlaceholder',
  BlogPostListing = 'BlogPostListing',
  LatestBlogPosts = 'LatestBlogPosts',
  HorizontalLine = 'HorizontalLine',
  BlogCategoryTitle = 'BlogCategoryTitle',
  BlogCategoryDescription = 'BlogCategoryDescription',
  Comments = 'Comments',
  WebinarSessionLink = 'WebinarSessionLink',
  WebinarSessionVideo = 'WebinarSessionVideo',
  WebinarSessionDateTime = 'WebinarSessionDateTime',
  OfferPrice = 'OfferPrice',
  LatestBlogPostsCarousel = 'LatestBlogPostsCarousel',
  OrderBump = 'OrderBump',
  ContactUsField = 'ContactUsField',
  Audio = 'Audio',
  Product = 'Product',
  WebinarCallToAction = 'WebinarCallToAction',
  SalesRedirectionButton = 'SalesRedirectionButton',
  FacebookComments = 'FacebookComments', // removed
  OptInRecaptcha = 'OptInRecaptcha',
  //will be used instead of Recaptcha in the contact us form
  ContactUsRecaptcha = 'ContactUsRecaptcha',
  CustomerType = 'CustomerType',
  PaymentMethod = 'PaymentMethod',
  Row = 'Row',
  Column = 'Column',
  LanguageSwitcher = 'LanguageSwitcher',
  Section = 'Section',
  RawHtml = 'RawHtml',
  Checkbox = 'Checkbox',
  ShippingFees = 'ShippingFees',
  BulletList = 'BulletList',
  Coupon = 'Coupon',
  PaymentButton = 'PaymentButton',
  BookingCalendar = 'BookingCalendar',
  BookingPaidCalendar = 'BookingPaidCalendar',
  Agreement = 'Agreement',
  BookingCalendarPreview = 'BookingCalendarPreview', // only for the dashboard event's preview
  BookingCalendarReschedule = 'BookingCalendarReschedule', // only for the reschedule booking page
  InlineBody = 'InlineBody',
  BlogPageBody = 'BlogPageBody',
  BlogPostLayoutBody = 'BlogPostLayoutBody',
  RemotePopupBody = 'RemotePopupBody',
  Body = 'Body',
  BlogPostBody = 'BlogPostBody',
  Popup = 'Popup',
  PriceElement = 'PriceElement',

  TwoStepPaymentForm = 'TwoStepPaymentForm',
  TwoStepPaymentFormStepPayment = 'TwoStepPaymentFormStepPayment',
  TwoStepPaymentFormStepOptIn = 'TwoStepPaymentFormStepOptIn',
  SearchResults = 'SearchResults',
  Search = 'Search',
  NavigationMenu = 'NavigationMenu',

  // Website entities section
  WebsiteLayoutBody = 'WebsiteLayoutBody',
  WebsitePageBody = 'WebsitePageBody',
  WebsiteBlogPageBody = 'WebsiteBlogPageBody',
  WebsiteBlogPostBody = 'WebsiteBlogPostBody',
  WebsiteBlogPostLayoutBody = 'WebsiteBlogPostLayoutBody',
  WebsiteHeader = 'WebsiteHeader',
  WebsiteFooter = 'WebsiteFooter',
  WebsiteLogo = 'WebsiteLogo',
  WebsiteLogin = 'WebsiteLogin',
  WebsiteLanguageSwitcher = 'WebsiteLanguageSwitcher',
}

/**
 * Return type temporary is array, until inline is fully migrated
 * @param pageType
 */
export const getReadableRootEntityTypeByPageType = (pageType: PageTypeEnum) => {
  switch (pageType) {
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogStatic:
    case PageTypeEnum.BlogSearch:
      return [EntityTypeEnum.BlogPageBody]
    case PageTypeEnum.BlogPostBody:
      return [EntityTypeEnum.BlogPostBody]
    case PageTypeEnum.BlogPostLayout:
      return [EntityTypeEnum.BlogPostLayoutBody]
    case PageTypeEnum.Inline:
      return [EntityTypeEnum.InlineBody]
    case PageTypeEnum.Popup:
      return [EntityTypeEnum.RemotePopupBody]
    case PageTypeEnum.WebsiteLayout:
      return [EntityTypeEnum.WebsiteLayoutBody]
    case PageTypeEnum.WebsiteHome:
    case PageTypeEnum.WebsiteDefault:
    case PageTypeEnum.WebsiteLogin:
    case PageTypeEnum.WebsitePricing:
    case PageTypeEnum.WebsiteSearch:
      return [EntityTypeEnum.WebsitePageBody]
    case PageTypeEnum.WebsiteBlogHome:
    case PageTypeEnum.WebsiteBlogPostListing:
    case PageTypeEnum.WebsiteBlogCategory:
      return [EntityTypeEnum.WebsiteBlogPageBody]
    case PageTypeEnum.WebsiteBlogPost:
      return [EntityTypeEnum.WebsiteBlogPostBody]
    case PageTypeEnum.WebsiteBlogPostLayout:
      return [EntityTypeEnum.WebsiteBlogPostLayoutBody]
    default:
      return [EntityTypeEnum.Body]
  }
}

export default EntityTypeEnum
